import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading-list',
    templateUrl: './loading-list.component.html',
    styleUrls: ['./loading-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
